<template>
    <v-switch
            :input-value="value"
            :label="label"
            :disabled="disabled"
            @change="$emit('input', $event)"
    ></v-switch>
</template>

<script>
    export default {
        name: "SSwitch",
        props: {
            'value': [Boolean, String],
            'label': String,
            disabled: Boolean,
        },
    }
</script>

<style scoped>

</style>